import isElement from '../../scripts/util/isElement';
import bindEvent from '../../scripts/util/bindEvent';
import {forEach} from 'ramda';

const selectors = {
	el: '.js-avatar',
	preview: '.js-avatar-preview',
	input: '.js-avatar-input',
	error: '.js-avatar-error',
	wrapper: '.js-popup-form'
};

const classes = {
	loaded: 'avatar_state_loaded',
	error: 'avatar_state_error'
};

const maxSize = 5000000;
const message = 'Превышен максимальный размер (5мб)';

const checkSize = size => size > maxSize;

const setError = el => {
	el.classList.add('show');
	el.textContent = `${message}`;
};

const removeError = (warning, el) => {
	warning.classList.remove('show');
	el.classList.remove(classes.error);
};

const setImage = image => el => {
	el.style.backgroundImage = `url("${image}")`;
};

const onLoad = (reader, el) => () => {
	const wrapper = el.closest(selectors.wrapper);
	const preview = wrapper.querySelectorAll(selectors.preview);
	const result = reader.result;

	forEach(setImage(result), preview);

	el.classList.add(classes.loaded);
};

const onChange = e => {
	const target = e.target;
	const el = target.closest(selectors.el);
	const form = el.closest('form');
	const error = form.querySelector(selectors.error);
	const file = target.files[0];
	const size = file.size;
	const reader = new FileReader();

	if (checkSize(size)) {
		setError(error);
		return;
	}

	removeError(error, el);

	reader.addEventListener('load', onLoad(reader, el));
	reader.readAsDataURL(file);
};

export const reset = avatar => {
	const preview = avatar.querySelector(selectors.preview);
	avatar.classList.remove(classes.loaded);
	preview.removeAttribute('style');
};

const render = () => {
	if (isElement(selectors.el)) {
		bindEvent(selectors.input, 'change', onChange);
	}
};

export default render;
